import React, { useState } from 'react';
import { vars } from '../reactive';

const setCurrentAnimationPage = ({ newPage, animation, pageState }: { newPage: number; animation?: 'fade' | 'fade-out'; pageState: [number, React.Dispatch<React.SetStateAction<number>>] }) => {
  const [currentPage, setCurrentPage] = pageState;
  if (animation) {
    vars.formClass(animation);
  } else {
    newPage > currentPage ? vars.formClass('fade') : vars.formClass('fade-out');
  }

  setTimeout(() => {
    setCurrentPage(newPage);
  }, 50);
};

const useAnimatedPages = (defaultState: number) => {
  const pageState = useState(defaultState);
  const [currentPage] = pageState;
  const increaseCurrentPage = () => {
    setCurrentAnimationPage({
      newPage: currentPage + 1,
      pageState
    });
  };

  const decreaseCurrentPage = () => {
    setCurrentAnimationPage({
      newPage: currentPage - 1,
      pageState
    });
  };

  return {
    currentPage,
    increaseCurrentPage,
    decreaseCurrentPage,
    setCurrentAnimationPage: (newPage: number, animation?: 'fade' | 'fade-out') => setCurrentAnimationPage({ newPage, animation, pageState })
  };
};

export default useAnimatedPages;
